import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress harmless "ResizeObserver loop" notifications produced by Radix
// Select/Dialog inside CRA's webpack-dev-server overlay (dev-only warning).
const RESIZE_OBSERVER_LOOP_ERR =
  "ResizeObserver loop completed with undelivered notifications";
const RESIZE_OBSERVER_LOOP_ERR_LEGACY =
  "ResizeObserver loop limit exceeded";
window.addEventListener("error", (e) => {
  if (
    e.message === RESIZE_OBSERVER_LOOP_ERR ||
    e.message === RESIZE_OBSERVER_LOOP_ERR_LEGACY
  ) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
